<script setup lang="ts">
import { RestaurantFilters } from '~/lib/interfaces/restaurant'

const props = defineProps<{ filters: RestaurantFilters[] }>()

const emit = defineEmits(['toggle-filter'])

const orderActiveFilters = computed(() => {
  const activeFilters = props.filters.filter(filter => filter.state)
  const inactiveFilters = props.filters.filter(filter => !filter.state)
  return [...activeFilters, ...inactiveFilters]
})
</script>

<template>
  <Swiper slides-per-view="auto" class="mx-0 mt-3 flex flex-row gap-2 px-6 md:mt-0 md:px-0">
    <SwiperSlide
      v-for="filter in orderActiveFilters"
      :key="`restaurant-filters-${filter.text}`"
      data-test="restaurant-filters"
    >
      <FilterBubble
        :filter-text="filter.text"
        :is-filter-selected="filter.state"
        @click="emit('toggle-filter', filter.text)"
      />
    </SwiperSlide>
  </Swiper>
</template>

<style scoped>
.swiper-slide {
  @apply mr-4 w-fit;
}

.swiper {
  @apply mx-0 p-1;
}
</style>
